import React from 'react';
import { FaRecycle } from "react-icons/fa"
import './box.css'

const index = ({ title, subTitle, loading, value, icon }) => {
  return (
    <div>
      <div className="box">
        <div className="feilds">
          <div className="box_header">
            {icon}
            <p className="title">{title}</p>
          </div>
          <p className="detail">{loading ? "loading..." : value}</p>
          <p className="sub_title">{subTitle}</p>
        </div>
      </div>
    </div>
  );
}

export default index;
